
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { format } from 'date-fns';
import { map } from 'rxjs/operators';

import { NoteDetails, NoteTarget, UpdateNoteGQL, UpdateNoteInput } from 'generated/graphql';

import { NOTE_CHANGES } from 'app/note/note.actions';
import { ToastrService } from 'core/toastr.service';
import { asDateOrNull } from 'helpers';

@Component({
  selector: 'app-note-edit',
  templateUrl: './note-edit.component.html'
})
export class NoteEditComponent implements OnChanges {
  form: UntypedFormGroup;
  @Input() targetId: string;
  @Input() targetType: NoteTarget;
  @Input() note: NoteDetails.Fragment;

  @Output() noteSaved = new EventEmitter<NoteDetails.Fragment>();
  @Output() canceled = new EventEmitter<any>();

  get campaignId() {
    return this.route.snapshot.queryParamMap.get('campaignId');
  }

  constructor(
    private route: ActivatedRoute,
    private toastrService: ToastrService,
    private updateNoteGQL: UpdateNoteGQL,
    private _store: Store,
    formBuilder: UntypedFormBuilder) {
    this.form = formBuilder.group({
      text: [null, [Validators.required]]
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['note']) {
      const change: { text: string } = changes['note'].currentValue;
      this.form.get('text').setValue(
        this.toInputValue(change.text)
      );
    }
  }

  onCancel() {
    this.canceled.emit(true);
  }

  onSave(form) {
    const input = this.prepareMutation();

    this.updateNoteGQL.mutate({ input }).pipe(
      map(({ data }) => data?.updateNote.note)
    )
      .subscribe({
        next: (note) => {
          form.reset();
          this._store.dispatch(NOTE_CHANGES({
            payload: {
              targetId: this.targetId,
              targetType: this.targetType,
              campaignId: this.campaignId
            }
          }));
          this.noteSaved.emit(note);
          this.toastrService.success('Note Updated');
        },
        error: (err) => this.toastrService.error(err)
      });
  }

  private prepareMutation(): UpdateNoteInput {
    return {
      campaignId: this.campaignId,
      targetType: this.targetType,
      noteId: this.note.id,
      changes: {
        text: this.asNoteTextForGQLInput(this.form.value.text)
      }
    };
  }

  private toInputValue(value: any) {
    if (this.note.noteType === 'date') {
      return this.toDate(value);
    } else {
      return value;
    }
  }

  private asNoteTextForGQLInput(value: any) {
    if (this.note.noteType === 'date') {
      return format(value, 'yyyy-MM-dd');
    }

    return value;
  }

  private toDate(dateString: Date) {
    return asDateOrNull(dateString);
  }
}
